<template>
  <main class="service-page">
    <div class="container">
      <div class="small-content">
        <h1 class="section-title">
          Terms of Service –  jeDAO Foundation (Mr. Canceller and jeDAO protocol)
        </h1>
        <span class="content-text">
          <strong>Effective Date:</strong> 05.01.2025
        </span>
        <h2 class="section-title small">
          1. Acceptance of Terms
        </h2>
        <p class="content-text">
          By accessing or using <strong class="text-yellow-100">canceller.finance</strong> website or any associated smart contract within jeDAO protocol, you agree to be legally bound by these Terms of Service (“Terms”). If you do not agree, do not use the Service.
        </p>
        <h2 class="section-title small">
          2. Nature of the Service
        </h2>
        <div class="content-text">
          <p>
            The Service provides access to decentralized finance tools via smart contracts on public blockchain networks. We:
          </p>
          <br />
          <ul class="service-page-list">
            <li>
              Do not control user assets
            </li>
            <li>
              Do not hold custody of funds
            </li>
            <li>
              Do not perform user identification or KYC
            </li>
          </ul>
          <p>
            All transactions are executed via self-custodied wallets.
          </p>
        </div>
        <h2 class="section-title small">
          3. Eligibility
        </h2>
        <div class="content-text">
          <p>
            You must:
          </p>
          <br />
          <ul class="service-page-list">
            <li>
              Be at least 18 years old (or the legal age in your jurisdiction)
            </li>
            <li>
              Have the full legal capacity to enter into agreements
            </li>
            <li>
              Not be a resident of any jurisdiction in which using the Service is prohibited
            </li>
          </ul>
          <p>
            We reserve the right to restrict access to the Service at our discretion.
          </p>
        </div>
        <h2 class="section-title small">
          4. Assumption of Risk
        </h2>
        <div class="content-text">
          <p>
            You use the Service at your own risk. By interacting with smart contracts, you acknowledge and agree:
          </p>
          <br />
          <ul class="service-page-list">
            <li>
              Blockchain transactions are irreversible
            </li>
            <li>
              The Service is provided “as-is” and may contain bugs or vulnerabilities
            </li>
            <li>
              You may experience loss due to smart contract exploits, token volatility, wallet errors, or third-party integrations
            </li>
          </ul>
          <p>
            You are fully responsible for managing your private keys and assets.
          </p>
        </div>
        <h2 class="section-title small">
          5. No Financial Advice
        </h2>
        <p class="content-text">
          The Service is a technology platform and <strong>does not offer financial, investment, tax, or legal advice.</strong> All interactions are self-directed and at your sole discretion.
        </p>
        <h2 class="section-title small">
          6. Prohibited Conduct
        </h2>
        <div class="content-text">
          <p>
            You agree <strong>not to</strong>:
          </p>
          <br />
          <ul class="service-page-list">
            <li>
              Use the Service in violation of any law or regulation
            </li>
            <li>
              Use the Service for money laundering, terrorist financing, or sanctions violations
            </li>
            <li>
              Attack, disrupt, or interfere with the platform, smart contracts, or infrastructure
            </li>
          </ul>
          <p>
            We reserve the right to restrict or block usage to maintain the integrity of the Service.
          </p>
        </div>
        <h2 class="section-title small">
          7. Limitation of Liability
        </h2>
        <div class="content-text">
          <p>
            To the maximum extent permitted by law:
          </p>
          <br />
          <ul class="service-page-list">
            <li>
              We are not liable for any indirect, incidental, or consequential damages
            </li>
            <li>
              We are not liable for losses due to smart contract errors, token volatility, or third-party integrations
            </li>
            <li>
            Your sole remedy is to stop using the Service
            </li>
          </ul>
        </div>
        <h2 class="section-title small">
          8. Intellectual Property
        </h2>
        <div class="content-text">
          Unless otherwise stated, all rights to the front-end interface, trademarks, and branding belong to jeDAO foundation. You may not reproduce or use our content without permission.
          <br />
          Smart contracts may be open-source and licensed separately.
        </div>
        <h2 class="section-title small">
          9. Termination
        </h2>
        <p class="content-text">
          We reserve the right to terminate or restrict access to the Service at any time, without notice, for any reason, including violation of these Terms.
        </p>
        <h2 class="section-title small">
          10. Modifications
        </h2>
        <p class="content-text">
          We may amend these Terms from time to time. Continued use of the Service after an update constitutes your acceptance of the revised Terms.
        </p>
        <h2 class="section-title small">
          10. Modifications
        </h2>
        <p class="content-text text-yellow-100">
          We may amend these Terms from time to time. Continued use of the Service after an update constitutes your acceptance of the revised Terms.
        </p>
      </div>
    </div>
  </main>
</template>

<script setup>
const config = useRuntimeConfig()

useHead({
  link: [
    {
      rel: 'canonical',
      href: `${config.public.appBaseUrl}/terms-of-service`
    },
  ]
})

useSeoMeta({
  title: getContent('seo.terms_of_service_title'),
  description: getContent('seo.terms_of_service_description'),
  ogTitle: getContent('seo.terms_of_service_og_title'),
  ogDescription: getContent('seo.terms_of_service_og_description'),
  ogUrl: `${config.public.appBaseUrl}/terms-of-service`,
})
</script>